<!-- User Profile Modal -->
<div class="modal fade" id="userProfileModal" tabindex="-1" aria-labelledby="userProfileModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-dark text-white border-secondary shadow-lg overflow-hidden">
            @if (user()) {
            <!-- Profile Nameplate Banner -->
            <div class="profile-nameplate p-5 text-center border-bottom border-secondary position-relative"
                [class.cursor-pointer]="isMe()"
                [attr.data-bs-toggle]="isMe() ? 'modal' : null"
                [attr.data-bs-target]="isMe() ? '#nameplateChangeModal' : null"
                [title]="isMe() ? 'Click to Change Nameplate' : ''"
                [style.background-image]="user()?.backgroundUrl || 'linear-gradient(135deg, #1f1f1f 0%, #111111 100%)'"
                style="background-size: cover; background-position: center; min-height: 160px;">

                @if (isMe()) {
                <div class="position-absolute top-0 end-0 m-2 badge bg-dark bg-opacity-75 border border-secondary text-white small">
                    <i class="bi bi-pencil-fill me-1"></i>Change Nameplate
                </div>
                }

                <!-- Avatar centered on Banner -->
                <div class="avatar-wrapper position-absolute start-50 translate-middle-x" style="bottom: -40px;">
                    <img [src]="'https://static.h5arena.com/images/avatars/' + getPortraitUrl(user().portraitId)"
                        class="rounded-circle border border-4 border-dark shadow-lg"
                        style="width: 90px; height: 90px; object-fit: cover;" alt="Avatar">
                </div>
            </div>

            <!-- Profile Info & Badges -->
            <div class="modal-body pt-5 px-4 pb-4">
                <div class="text-center mt-2 mb-4">
                    <h4 class="fw-bold mb-1 d-inline-flex align-items-center justify-content-center gap-1"
                        [style.color]="user().userNameColor || '#ffffff'">
                        <span>{{ user().userName }}</span>
                        @if (isParentLobbyOwner()) {
                        <i class="fas fa-feather-alt text-warning fs-5" title="Lobby Owner"></i>
                        }
                    </h4>
                    <span class="badge" [style.background-color]="getStatusColor(user().status)">
                        {{ getStatusText(user().status) }}
                    </span>
                </div>

                <hr class="border-secondary my-4">

                <!-- Assigned Icons / Badges Section -->
                <div>
                    <h6 class="text-uppercase small fw-bold text-secondary mb-3 text-center">Assigned Icons</h6>

                    @if (user().userIcons && user().userIcons.length > 0) {
                    <div class="d-flex flex-wrap justify-content-center gap-3">
                        <!-- No Icon Option -->
                        @if (isMe()) {
                        <div class="icon-item-wrapper d-flex flex-column align-items-center">
                            <button class="btn icon-btn rounded d-flex align-items-center justify-content-center border"
                                [class.border-danger]="!hasActiveIcon()" [class.border-secondary]="hasActiveIcon()"
                                [class.active-glow]="!hasActiveIcon()" (click)="selectIcon(null)" title="No Icon"
                                style="width: 50px; height: 50px; background-color: rgba(255, 255, 255, 0.05);">
                                <i class="bi bi-slash-circle fs-4 text-muted"></i>
                            </button>
                            <span class="small text-muted mt-1" style="font-size: 0.75rem;">None</span>
                        </div>
                        }

                        @for (icon of user().userIcons; track icon.id) {
                        <div class="icon-item-wrapper d-flex flex-column align-items-center">
                            <button class="btn icon-btn rounded p-1 border" [class.border-danger]="icon.active"
                                [class.border-secondary]="!icon.active" [class.active-glow]="icon.active"
                                [disabled]="!isMe()" (click)="selectIcon(icon)" [title]="icon.description || 'Icon'"
                                style="width: 50px; height: 50px; background-color: rgba(0,0,0,0.2);">
                                <img [src]="'https://static.h5arena.com/images/icons/' + icon.fileName"
                                    class="img-fluid" [alt]="icon.description">
                            </button>
                            <span class="small text-muted mt-1 text-truncate"
                                style="font-size: 0.75rem; max-width: 65px;">
                                {{ icon.description || 'Icon' }}
                            </span>
                        </div>
                        }
                    </div>
                    } @else {
                    <div class="text-center py-3 text-muted">
                        <i class="bi bi-shield-slash fs-3 mb-2 d-block"></i>
                        <p class="small mb-0">No icons assigned to this user.</p>
                    </div>
                    }
                </div>
            </div>

            <!-- Footer Close Button -->
            <div class="modal-footer border-0 p-0">
                <button type="button" class="btn btn-danger w-100 m-0 rounded-0 py-3 fw-bold"
                    data-bs-dismiss="modal">Close</button>
            </div>
            }
        </div>
    </div>
</div>